
import { FirearmStorageLocationPLITypeInfoBase } from './firearm-storage-location-pli.typeinfo.base';


export class FirearmStorageLocationPLITypeInfo extends FirearmStorageLocationPLITypeInfoBase {
}

export const FIREARM_STORAGE_LOCATION_PLI_TYPE: FirearmStorageLocationPLITypeInfo = new FirearmStorageLocationPLITypeInfo();



